var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { forwardRef, useImperativeHandle, useState } from 'react';
import classNames from 'classnames';
import { CircularProgress } from '@mui/material';
export var EXPORT_OVERLAY_CSS_CLASSNAME = 'exportToPdfOverlay';
var delay = function (ms) { return new Promise(function (resolve) { return setTimeout(resolve, ms); }); };
var PdfExportOverlayComponent = function (_a, forwardedRef) {
    var children = _a.children, className = _a.className, id = _a.id, constructStyle = _a.constructStyle;
    var _b = useState(false), isAutoHeight = _b[0], setIsAutoHeight = _b[1];
    var _c = useState(false), isOverlayVisible = _c[0], setIsOverlayVisible = _c[1];
    useImperativeHandle(forwardedRef, function () { return ({
        export: function (exportFunction) {
            setIsOverlayVisible(true);
            delay(100) // wait to overlay to be fully animated
                .then(function () { return setIsAutoHeight(true); })
                .then(function () { return delay(200); }) // wait to adjust diagram to new height
                .then(function () { return exportFunction(); })
                .finally(function () {
                setIsAutoHeight(false);
                setIsOverlayVisible(false);
            });
        }
    }); });
    var divProps = {
        id: id,
        className: className
    };
    return (React.createElement("div", __assign({}, divProps, { style: constructStyle ? constructStyle(isAutoHeight) : undefined }),
        children,
        React.createElement("div", { className: classNames(EXPORT_OVERLAY_CSS_CLASSNAME, {
                'fade-out': !isOverlayVisible,
                'fade-in': isOverlayVisible
            }) },
            React.createElement(CircularProgress, null))));
};
export var PdfExportOverlay = forwardRef(PdfExportOverlayComponent);
//# sourceMappingURL=PdfExportOverlay.js.map